<template>
  <v-col cols="3">
    {{ $t('login.wait') }}
    <v-progress-linear indeterminate></v-progress-linear>
  </v-col>
</template>

<script>
import Mixins from '@/mixins/app_init'
import events from 'Store/events'
import api from '@/api'
import Session from '@/api/session'
import EmbeddedLocalStorage from '@/api/embedded'
import ChatLocalStorage from '@/api/chat'
import { mapActions } from 'vuex'

export default {
  name: 'login-token',
  mixins: [Mixins],
  mounted () {
    Session.clear()
    ChatLocalStorage.setSmsFilters([])
    EmbeddedLocalStorage.set(false)
    const code = this.$route.query.code
    if (!code) {
      this.dbg('Invalid or missing code parameter')
      events.pubError(this.$t('login.error.oauth2'))
      this.signout()
      return
    }
    // oauth login
    api.oauthAppCallpanel().then(({ data }) => {
      const { client_id: cid, redirect_uri: ruri } = data
      if (!cid || !ruri) {
        this.dbg('response error: %o', data)
        throw new Error('empty response data')
      }

      return api.tokenLogin(cid, code, ruri)
    }).then(async resp => {
      this.dbg(resp)
      await this.initCallpanel() // function in mixins
    }).catch(err => {
      const error = err.response || err
      this.dbg(error)
      events.pubError(this.$t('login.error.oauth2') + ': ' + err)
      this.signout()
    })
  },
  methods: {
    ...mapActions({
      authReset: 'authReset',
      sipuaDestroy: 'sipuaDestroy'
    }),
    async signout () {
      Session.clear()
      this.authReset()
      await this.sipuaDestroy()
      location.reload(true)
    }
  }
}
</script>

<style scoped>
</style>
